import { shortenString } from "./shortenString";

export const shortenReceiverId = (value: string, maxLength: number = 20) => {
  if (value.length <= maxLength) {
    return value;
  }

  const atIndex = value.indexOf("@");

  if (atIndex === -1) {
    return shortenString(value, Math.floor(maxLength / 2));
  }

  const username = value.slice(0, atIndex);
  const domain = value.slice(atIndex); // includes "@"

  if (domain.length <= 12) {
    const usernameChars = maxLength - domain.length - 1; // -1 for the ellipsis
    if (usernameChars > 0) {
      return `${username.slice(0, usernameChars)}…${domain}`;
    }
  }

  return shortenString(value, Math.floor(maxLength / 2));
};
